import { useState } from "react";
import Icon from "../Icon";
import { BtnPrimary, BtnGhost, ModalFt } from "../Atoms";
import Campo from "./Campo";
import { colorNombre, iconoNombre } from "../../colorNombre";

export default function TeamForm({onSave,onClose,inS,lbS,team}) {
  const TEAM_ICONS = [
    "people-fill","people","person","person-badge","person-check-fill",
    "star-fill","lightning-fill","rocket-takeoff-fill","lightbulb-fill","flag",
    "bar-chart-fill","pie-chart-fill","graph-up-arrow","kanban-fill","grid-3x3-gap-fill",
    "code-slash","cpu-fill","hdd-network-fill","tools","gear",
    "palette-fill","camera-fill","megaphone-fill","globe","funnel-fill",
    "currency-euro","bank","cart-fill","briefcase-fill","building",
    "headset","chat-dots-fill","shield-lock","shield-check","key",
    "mortarboard-fill","journal-text","file-text","clipboard","bookmark-check-fill",
    "truck","boxes","heart-pulse-fill","calendar3","clock",
    "folder2-open","inbox","bell","check2-square","list-ul",
  ];
  const [f,setF]=useState({
    name:  team?.name  || "",
    color: team?.color || "#0b7d96",
    icon:  team?.icon  || "people-fill",
    // Los miembros se preservan tal cual — se gestionan desde "Modificar miembros"
    members: team?.members || [],
  });
  const COLS=["#0b7d96","#3b82f6","#8b5cf6","#ec4899","#ef4444","#f59e0b","#22c55e","#14b8a6","#6b7280","#a16207","#0096b7","#dc2626"];
  return (
    <div>
      <h3 style={{margin:"0 0 16px",fontWeight:700,fontSize:16,display:"flex",alignItems:"center",gap:8}}><Icon name={team?"pencil-square":"people-fill"} size={15} color="var(--accent)"/>{team?"Editar":"Nuevo"} equipo</h3>
      <Campo><label style={lbS}>Nombre / Departamento</label><input value={f.name} onChange={e=>setF(p=>({...p,name:e.target.value}))} placeholder="Ej: Diseño, Desarrollo…" style={inS}/></Campo>
      <Campo><label style={lbS}>Color</label>
      <div style={{display:"flex",gap:8,marginBottom:14,flexWrap:"wrap"}}>{COLS.map(c=><button key={c} aria-label={"Color "+colorNombre(c)} aria-pressed={f.color===c} className="btn" onClick={()=>setF(p=>({...p,color:c}))} style={{width:26,height:26,borderRadius:"50%",background:c,border:f.color===c?"3px solid #111827":"3px solid transparent",cursor:"pointer",padding:0,transform:f.color===c?"scale(1.2)":"scale(1)",transition:"transform .13s"}}/>)}</div>
      </Campo>
      <Campo><label style={lbS}>Icono del equipo</label>
      <div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:14,maxHeight:200,overflowY:"auto"}}>
        {TEAM_ICONS.map(ic=>(
          <button key={ic} className="btn" onClick={()=>setF(p=>({...p,icon:ic}))} title={iconoNombre(ic)} aria-label={"Icono "+iconoNombre(ic)} aria-pressed={f.icon===ic}
            style={{width:34,height:34,borderRadius:8,border:"2px solid "+(f.icon===ic?f.color:"var(--border)"),background:f.icon===ic?f.color+"18":"var(--bg)",cursor:"pointer",padding:0,display:"flex",alignItems:"center",justifyContent:"center",transition:"all .12s",transform:f.icon===ic?"scale(1.1)":"scale(1)"}}>
            <Icon name={ic} size={14} color={f.icon===ic?f.color:"var(--text3)"}/>
          </button>
        ))}
      </div></Campo>
      <ModalFt onClose={onClose} label={team?"Guardar cambios":"Crear equipo"} onSave={()=>f.name.trim()&&onSave(f)} disabled={!f.name.trim()}/>
    </div>
  );
}
